import Linkify from "react-linkify";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

// react-linkify 1.x usa componentDecorator (a prop "properties" era da versão 0.x).
const linkDecorator = (href, text, key) => (
  <Link
    key={key}
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    color="inherit"
    underline="always"
    onClick={(event) => event.stopPropagation()}
  >
    {text}
  </Link>
);

const Mensagem = ({ sm }) => {
  if (!sm.mensagem) return null;

  return (
    <Typography variant="body2" component="div" sx={{ whiteSpace: "pre-line", overflowWrap: "anywhere" }}>
      <Linkify componentDecorator={linkDecorator}>{sm.mensagem}</Linkify>
    </Typography>
  );
};

export default Mensagem;
